import { Fragment } from "react"
import { Box, Typography, SxProps, Divider } from "@mui/material"
import _ from "lodash"
import { useTranslation } from "providers/i18n"
import { ShopListItem } from "components/domains/directory"
import { OccupantData } from "providers/venue/types"
import { formatLevelName } from "utils/feature"

interface IShopListItemWithHeaderProps {
  pages: Array<{ data: OccupantData[] }>
  hideLevel?: boolean
  showSubCategoryFilter?: boolean
  levelHeaderSx?: SxProps
  dividerSx?: SxProps
}

export const ShopListItemWithHeader = ({
  pages,
  hideLevel = false,
  showSubCategoryFilter = false,
  levelHeaderSx,
  dividerSx,
}: IShopListItemWithHeaderProps) => {
  const { t } = useTranslation()
  const renderedLevels = new Set<string>()

  return (
    <>
      {pages.map((page, pageNum) => {
        // Group occupants by level_name
        const groupedByLevel = _.groupBy(page.data, "properties.level_name")
        // Sort groups by ordinal (descending)
        const sortedGroups = _.orderBy(
          Object.entries(groupedByLevel),
          ([, occupants]) => _.get(occupants, "[0].properties.ordinal", 0),
          ["desc"]
        )

        return (
          <Fragment key={pageNum}>
            {sortedGroups.map(([level, occupants]) => {
              const shouldShowHeader = !renderedLevels.has(level)
              if (shouldShowHeader) {
                renderedLevels.add(level)
              }

              const levelKey = formatLevelName(level)

              return (
                <Fragment key={`${pageNum}-${level}`}>
                  {shouldShowHeader && (
                    <Box
                      className={
                        showSubCategoryFilter ? "with-sub-category" : ""
                      }
                      sx={levelHeaderSx}
                    >
                      <Typography variant="h6">
                        {t(`Level Name.${levelKey}`)}
                      </Typography>
                      <Divider sx={dividerSx} />
                    </Box>
                  )}
                  {occupants.map((occupant) => {
                    const isAd = occupant?.properties?.isAd

                    return (
                      <ShopListItem
                        occupant={occupant}
                        key={`${isAd ? "ad-" : "directory-item-"}${
                          occupant.id
                        }`}
                        hideLevel={hideLevel}
                      />
                    )
                  })}
                </Fragment>
              )
            })}
          </Fragment>
        )
      })}
    </>
  )
}
